import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Star, Sparkles } from "lucide-react";
import ShareableAchievement from "@/components/ShareableAchievement";

interface LevelUpModalProps {
  open: boolean;
  onClose: () => void;
  newLevel: number;
  userName?: string;
}

export default function LevelUpModal({ open, onClose, newLevel, userName }: LevelUpModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[340px] text-center p-8">
        <div className="flex flex-col items-center gap-4">
          <div className="relative">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center animate-pulse">
              <Star className="w-10 h-10 text-white fill-white" />
            </div>
            <Sparkles className="absolute -top-2 -right-2 w-6 h-6 text-yellow-500" />
            <Sparkles className="absolute -bottom-1 -left-2 w-5 h-5 text-primary" />
          </div>
          
          <div className="space-y-2">
            {/* Solid colored title — bypasses Calm's gradient hijack on
                amber clip-text (founder report 2026-06-02: gradient
                text became invisible in Calm). */}
            <h2 className="text-2xl font-bold" style={{ color: "#f59e0b" }}>
              Level Up!
            </h2>
            <p className="text-muted-foreground">
              Congratulations! You've reached
            </p>
            <div className="text-4xl font-bold text-primary">
              Level {newLevel}
            </div>
          </div>
          
          <p className="text-sm text-muted-foreground">
            Keep up the great work on your habits!
          </p>

          <div className="flex items-center gap-2 w-full">
            <Button onClick={onClose} className="flex-1">
              Continue
            </Button>
            <ShareableAchievement
              type="levelup"
              title="Level Up!"
              subtitle="Keep up the great work on your habits!"
              value={`Level ${newLevel}`}
              emoji="⭐"
              userName={userName}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
